import React from 'react'
import styled from 'styled-components'
import { injectState } from 'freactal'
import UnstyledContentSection from '../../../components/ContentSection'
import { getSectionHeading } from '../../../lib'
import { TABLE_BLUE } from '../../../colors'
import TransformedImage from '../../../components/TransformedImage'
import ImageThumbnail from '../../../components/ImageThumbnail'

const Container = styled.div`
  position: relative;
  display: inline-block;
  border: 1px solid grey;
  width: 25.4cm;
  height: 19.05cm;
`
const Header = styled.div`
  margin-top: 0.5cm;
  margin-left: 0.5cm;
  display: flex;
  align-items: center;
  height: 3cm;
  color: ${TABLE_BLUE};
  line-height: 1.05em;
  font-weight: bold;
  font-size: ${({ fontSize }) => fontSize}pt;
`
const ContentSection = styled(UnstyledContentSection)`
  margin-top: 0.5cm;
  margin-left: 0.5cm;
  * {
    font-size: 24pt;
    line-height: 1.32em;
  }
  ul,
  ol {
    margin: 0;
  }
  width: ${({ image, imageWidth, imageAlignment = 'right' }) =>
    24.4 - (!image || imageAlignment === 'center' ? 0 : imageWidth + 0.8)}cm;
`
const ImageContainer = styled.div`
  margin-top: 0.5cm;
  margin-left: auto;
  margin-right: auto;
  width: ${({ imageWidth }) => imageWidth}cm;
  position: absolute;
  bottom: 0.5cm;
  ${({ imageAlignment = 'right' }) =>
    imageAlignment === 'center'
      ? `
    left: 25%;
    right: 25%`
      : 'right: .5cm'};
`
const Image = styled(TransformedImage)`width: 100%;`

class Slide extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { unit, slide, useThumbnail } = nextProps
    if (
      this.props.unit === unit &&
      this.props.slide === slide &&
      this.props.useThumbnail === useThumbnail
    ) {
      return false
    }
    return true
  }

  render() {
    const { state: { unit }, slide, useThumbnail, ...restProps } = this.props
    const { image, content, sectionIndex } = slide
    const { display: { width = 5.5, align = 'right' } = {} } = image || {}
    const headerFontSize = 36 - (sectionIndex.length - 2) * 4
    return (
      <Container {...restProps}>
        <Header fontSize={headerFontSize}>
          <span>{getSectionHeading(unit, sectionIndex)}</span>
        </Header>
        <ContentSection
          content={content}
          image={image}
          imageWidth={width}
          imageAlignment={align}
        />
        {image && (
          <ImageContainer imageWidth={width} imageAlignment={align}>
            {useThumbnail ? (
              <ImageThumbnail imageId={image.mediaId} />
            ) : (
              <Image image={image} />
            )}
          </ImageContainer>
        )}
      </Container>
    )
  }
}

export default injectState(Slide)



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/PresentationContent/Slide.js